// src/hooks/useSelectedImageryKeys.js
//
// Explore's selected captures (footprint restyle S-c1): the dataset_key each
// drawn imagery layer resolves to right now, topmost first, for
// useFootprintOverlay's selectedKeys. The store's resolver (getRenderSpecs →
// resolveImageryStack) honors pinned vs follow-cursor; degraded and hidden
// layers draw nothing, so they select nothing. In compare, each pane selects
// only its own layer (the one paneImageryIds lets it draw). Replaces
// useActiveImageryDatasetIds (S-b's interim, by dataset_id and feature-state).
import { useMemo } from "react";
import { useImageryStackStore } from "../stores/useImageryStackStore";

/**
 * @param {Array<{layer_id: string, dataset_key: string|null, visible: boolean, z_index: number, degraded: string|null}>} specs
 * @param {{enabled: boolean, left_layer_id: string|null, right_layer_id: string|null}|null} compareMode
 * @param {'left'|'right'} pane  which compare side this map is (the main map is left)
 * @returns {string[]} dataset_keys, highest z_index first, each once
 */
export function selectedImageryKeys(specs, compareMode, pane = "left") {
  const own = compareMode?.enabled ? (pane === "right" ? compareMode.right_layer_id : compareMode.left_layer_id) : undefined;
  const keys = [];
  for (const s of [...(specs ?? [])].sort((a, b) => b.z_index - a.z_index)) {
    if (s.degraded || !s.visible || !s.dataset_key) continue;
    if (own !== undefined && s.layer_id !== own) continue;
    if (!keys.includes(s.dataset_key)) keys.push(s.dataset_key);
  }
  return keys;
}

export function useSelectedImageryKeys(pane = "left") {
  const stack = useImageryStackStore((s) => s.stack);
  const catalog = useImageryStackStore((s) => s.catalog);
  const cursor = useImageryStackStore((s) => s.cursor);
  const compareMode = useImageryStackStore((s) => s.compareMode);
  // stack, catalog and cursor are what getRenderSpecs reads.
  return useMemo(() => selectedImageryKeys(useImageryStackStore.getState().getRenderSpecs(), compareMode, pane),
    [stack, catalog, cursor, compareMode, pane]); // eslint-disable-line react-hooks/exhaustive-deps
}
